import { render, staticRenderFns } from "./TaggingSelection.vue?vue&type=template&id=0a26af58&scoped=true"
import script from "./TaggingSelection.vue?vue&type=script&lang=js"
export * from "./TaggingSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a26af58",
  null
  
)

export default component.exports